import React, { useMemo } from 'react'
import { Controller } from 'react-hook-form'
import Select from 'react-select'

const SelectContractStatus = ({ control, required = false ,defaultValue }) => {

    const titleOptions = useMemo(() => {
        return [
            { value: 'ACTIVE', label: 'สัญญาปกติ' },
            { value: 'CANCEL', label: 'ยกเลิกสัญญาแล้ว' },
            { value: '', label: 'ทุกสถานะ' },
        ]
    }, [])

    return (
        <Controller
            name="status"
            control={control}
            rules={{ required: required }}
            defaultValue={defaultValue && titleOptions.find(v=>v.value===defaultValue)}
            render={({ field }) => <Select options={titleOptions} placeholder="เลือก" {...field}  />}
        />
    )
}

export default SelectContractStatus
